// 등록 · 저장 · 삭제 실패 알림의 번역 키 — 충돌(409)일 때만 「중복 레코드인지 · 다른 곳에서 사용 중인지 확인하세요」를 붙인
// error.<kind>Conflict, 그 밖의 실패(400 · 404 · 500 …)는 사유만 보이는 error.<kind>Failure (kind: insert · update · delete)
// status 가 배열이면(일괄 삭제의 줄별 상태 statuses — autoGenApi/bulkDelete.js) 모든 줄이 409 일 때만 충돌로 본다
function failureKey ( kind, status ) {

    const conflict = Array.isArray ( status ) ? status.length > 0 && status.every ( ( s ) => s === 409 ) : status === 409;

    return `error.${kind}${conflict ? "Conflict" : "Failure"}`;

}

export default failureKey;
